<template>
    <div class="Logo">
        <svg
            v-if="icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 167.4 118.5"
            xml:space="preserve"
        >
            <path d="M77.8 0L58.3 28.3h65l-32.8 90.2 40.9-19.8 36-98.7z"/>
            <path d="M86.7 35.3h-56L0 118.5h83.3L104.6 61 86.7 35.3zM61.8 92.6H39.7l11.1-29.2h14.8l4.8 6.8-8.6 22.4z"/>
        </svg>

        <svg
            v-else
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 433.4 93.1"
            xml:space="preserve"
        >
            <path d="M215.5 75.1l19.6-53.4h-93.2l-19.5 53.4h19.9l13.4-36.7h16.7L159 75.1h19.8l13.4-36.7h16.7l-13.4 36.7zM63.5 0H27.4L0 75.1h53.8l21.3-58.5L63.5 0zM39.9 58.4H25.7l14.7-40.3H50l3.1 4.4-13.2 35.9zM115.8 21.7l-13.7 37H85.4l13.7-37h-20L59.5 75.1h56.6l19.7-53.4zM241.3 21.7l-26 71.4H235l6.6-18h36.9L298 21.7h-56.7zm23.3 36.7h-16.7l7.7-20.6h16.7l-7.7 20.6zM361.3 38.4l-20.4 10 12.9 10h-17l7.4-20h24.7l6.1-16.7h-44.7l-19.5 53.4h44.7l6.1-16.7h-7.8zM433.4 21.7h-28.2l-5.4 3.8L409.1 0h-20l-27.2 75.1h19.9l6.8-18.5h16.6l-6.7 18.5h20l12.9-35.2h-22.8z"/>
            <path d="M279.5 0l-11.4 16.5h38l-23.4 64.3 24-11.5L331.9 0z"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'Logo',

    props: {
        icon: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.Logo {
    display: flex;

    svg {
        width: 100%;
        fill: $brand-primary;
    }

    &.white svg {
        fill: #fff;
    }
}
</style>